import * as apiClient from '../api/apiClient';
import { unwrapResponseModel } from './estadoCurricularDto';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function generarEstadoCurricular(alumnoxCarreraCod) {
  return requestAndUnwrap(apiClient.get(`/api/ecur/${alumnoxCarreraCod}`));
}
